import { coreGet, coreMutate } from "../../core-api/api-client";

export interface PasswordStatus {
  available: boolean;
  passwordRotatedAt: string | null;
}
export interface PersonalSignature {
  configured: boolean;
  htmlBody: string;
  textBody: string;
  version: number;
  updatedAt: string | null;
}
export interface PersonalTag {
  id: string;
  name: string;
  version: number;
  usageCount: number;
}

export const loadPasswordStatus = (signal?: AbortSignal) =>
  coreGet<PasswordStatus>("/personal-settings/password", signal);
export const changePersonalPassword = (body: {
  currentPassword: string;
  newPassword: string;
  repeatPassword: string;
}) => coreMutate<{ changed: true; passwordRotatedAt: string }>("/personal-settings/password", "PUT", body);
export const loadPersonalSignature = (signal?: AbortSignal) =>
  coreGet<PersonalSignature>("/personal-settings/signature", signal);
export const savePersonalSignature = (html: string) =>
  coreMutate<PersonalSignature>("/personal-settings/signature", "PUT", { html });
export const loadPersonalTags = (signal?: AbortSignal) =>
  coreGet<{ tags: PersonalTag[] }>("/personal-settings/tags", signal);
export const changePersonalTags = (
  body:
    | { action: "create"; name: string }
    | { action: "rename"; tagId: string; name: string; expectedVersion: number }
    | { action: "delete"; tagId: string; expectedVersion: number },
) => coreMutate<{ tags: PersonalTag[] }>("/personal-settings/tags", "POST", body);
